import React from 'react';

// Icone Plus (+)
export const PlusIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 5V19"
      stroke="black"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 12H19"
      stroke="black"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Icone Minus (-)
export const MinusIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 12H19"
      stroke="black"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowLeft = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="1.3" fill="none" />
  </svg>
);

export const ArrowRight = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="1.3" fill="none" />
  </svg>
);

export const GridIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path d="M3 3h7v7H3V3zm0 11h7v7H3v-7zm11 0h7v7h-7v-7zm0-11h7v7h-7V3z" fill="currentColor" />
  </svg>
);